import { styled, theme } from "@theme/stitches.config"
import { EffiePatternWrapper } from "@components/styles"

export const NewsletterWrapper = styled("div", {
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    overflow: "hidden",
    zIndex: 10,
    width: "100%",
    borderRadius: 6,
    backgroundColor: theme.colors.effieBackground,
    minHeight: 260,
    marginBottom: -130,
    py: 40,
    px: 90,
    "@lgUp": {
        maxHeight: 300
    },
    "@xxlDown": {
        px: 80
    },
    "@lgDown": {
        display: "block",
        padding: "90px 60px"
    },
    "@smDown": {
        py: 60,
        px: 40,
        borderRadius: 0,
        width: "100vw",
        bottom: 0,
        position: "relative",
        left: "50%",
        right: "50%",
        marginLeft: "-50vw",
        marginRight: "-50vw"
    }
})
export const Content = styled("div", {
    flex: "1 0 30%",
    maxWidth: "30%",
    zIndex: 10,
    position: "relative",
    "& h3": {
        color: theme.colors.N0,
        m: 0,
        mb: 10
    },
    "& p": {
        color: theme.colors.N0,
        opacity: 0.5
    },
    "@lgDown": {
        mb: 34,
        maxWidth: "none"
    }
})

export const FormWrapper = styled("div", {
    flex: "1 0 60%",
    maxWidth: "60%",
    ml: "auto",
    zIndex: 10,
    position: "relative",
    "@lgDown": {
        maxWidth: "none"
    }
})

export const Styledform = styled("form", {
    zIndex: 2,
    display: "flex",
    "> *": {
        px: 10,
        width: "100%",
        "& span": {
            color: theme.colors.N0,
            textTransform: "uppercase",
            fontSizePxToRem: 10,
            letterSpacing: 1
        }
    },
    "& button": {
        mt: 20,
        ml: 10,
        height: 48,
        lineHeight: 17,
        "@lgUp": {
            maxWidth: 145
        }
    },
    "@lgDown": {
        flexDirection: "column",
        "> *": {
            py: 5,
            px: 0
        },
        "& button": {
            width: "100%",
            mt: 37,
            ml: 0
        }
    }
})

export const StyledEffiePatternWrapper = styled(EffiePatternWrapper, {
    zIndex: 1,
    width: "auto",
    top: -290,
    left: 330,
    "& svg": {
        height: 875
    },
    "@smDown": {
        display: "none"
    }
})

export const Description = styled("p", {
    display: "flex",
    width: "100%",
    opacity: 0.5,
    color: theme.colors.N0,
    mt: 16,
    px: 10,
    "@lgDown": {
        px: 0
    }
})
